import Restore from "@mui/icons-material/Restore";
import { Button, ButtonProps, CircularProgress } from "@mui/material";

type Props = Pick<
  ButtonProps,
  "onClick" | "disabled" | "variant" | "fullWidth"
> & {
  loading?: boolean;
};

export const ResetReportButton = (props: Props) => {
  const { loading, ...buttonProps } = props;

  return (
    <Button
      variant={props.variant ?? "outlined"}
      size="small"
      color="info"
      startIcon={loading ? <CircularProgress size={16} /> : <Restore />}
      disabled={loading || props.disabled}
      {...buttonProps}
    >
      Reset report
    </Button>
  );
};
